import React, {Component} from 'react';
import './SearchCompany.scss';
import {Api} from "../../api";
import {connect} from 'react-redux';
import {checkAuth, getAuthToken} from "../../utils";
import ButtonInput from "../../components/Common/ButtonInput";

class SearchCompany extends Component {
    state = {
        certificateId: '',
        name: '',
        taxNumber: '',
        countryTitle: '',
        validTill: '',
        isLoading: true,
        companyHasSelected: false,
        hasSearched: false,
        companiesList: [],
        companiesSelectedNumber: 0,
        searchRow: ''
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const authToken = getAuthToken();
        const createModeData = JSON.parse(localStorage.getItem('company-create-mode-data'));
        console.log('createModeData: ' + createModeData);
        if (createModeData) {
            console.log('createModeData: ' + createModeData);
            Api.get('certificates?id=' + createModeData.certificateId, authToken)
                .then(response => {
                    const certificate = response.data.payload;
                    this.initCertificateData(certificate);
                    this.props.handleLoader(false);
                }).catch(error => {
                checkAuth(error.response, this.props.history);
            });
            return;
        }

        Api.get('certificates/current', authToken)
            .then(response => {
                if (response.data.length === 0) {
                    this.props.history.push('/user/personal-data/certificate-type-selection');
                } else {
                    const certificate = this.getCertificateWithoutCompany(response.data);
                    if (certificate == null) {
                        this.props.history.push('/user/personal-data/confirm-companies');
                        return;
                    }
                    this.initCertificateData(certificate);
                    this.props.handleLoader(false);
                }
            }).catch(error => {
            checkAuth(error.response, this.props.history);
        })
    }

    initCertificateData(certificate) {
        console.log(certificate);
        const taxNumber = certificate.taxNumber;
        const countryTitle = certificate.country;
        const validTill = certificate.validTill;
        const name = certificate.name;
        const certificateId = certificate.id;

        this.setState({
            certificateId: certificateId,
            isLoading: false,
            taxNumber: taxNumber,
            countryTitle: countryTitle,
            validTill: validTill,
            name: name
        });
    }

    getCertificateWithoutCompany = (certificates) => {
        for (const certificate of certificates) {
            let hasCompany = false;
            for (const company of certificate.companies) {
                if (company) {
                    hasCompany = true;
                }
            }

            if (!hasCompany) {
                return certificate;
            }
        }

        return null;
    };

    cancelCompanies = () => {
        this.setState({hasSearched: false, companyHasSelected: false, companiesList: []});
    };

    search = () => {
        const searchRow = this.state.searchRow;
        if (!searchRow || searchRow === '') {
            return;
        }

        const authToken = getAuthToken();
        Api.get('rik/companies?name=' + searchRow, authToken)
            .then(response => {
                const companiesList = response.data.map(company => {
                    company.selected = false;
                    return company;
                });
                this.setState({companiesList: companiesList, hasSearched: true});
                console.log('success');
            }).catch(error => {
            console.log(error.response.data);
            checkAuth(error.response, this.props.history);
        });
    };

    onChangeSearchValue = (event) => {
        this.setState({searchRow: event.target.value})
    };

    changeSelectedCompany = (index) => {
        const companiesList = this.state.companiesList;
        const willBeSelected = !companiesList[index].selected;
        for (const company of companiesList) {
            company.selected = false;
        }
        companiesList[index].selected = willBeSelected;

        this.setState({
            companiesList: companiesList,
            companyHasSelected: willBeSelected,
            selectedCompany: companiesList[index]
        })
    };

    next = () => {
        if (!this.state.companyHasSelected) {
            alert('Select company first');
        }
        const registrationDat = {
            certificateId: this.state.certificateId,
            name: this.state.name,
            taxNumber: this.state.taxNumber,
            countryTitle: this.state.countryTitle,
            validTill: this.state.validTill,
            companyCode: this.state.selectedCompany.code,
            companyName: this.state.selectedCompany.name
        };
        localStorage.removeItem('company-create-mode-data');
        localStorage.setItem('registration-company', JSON.stringify(registrationDat));
        console.log('registr trtrt');
        console.log(registrationDat);
        this.props.history.push('/user/personal-data/confirm-ee-company');
    };

    render() {
        const {hasSearched, companiesSelectedNumber, companiesList, selectedCompany, companyHasSelected, name, isLoading, taxNumber, countryTitle, validTill} = this.state;
        const expDate = new Date(validTill);
        console.log(countryTitle);
        return (!isLoading &&
            <div className={'content-wrapper'}>
                <div className={'content'}>
                    <div className={'row'}>
                        <div className={'col-lg-5'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Name</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={name}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col-lg-5 offset-lg-1'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Jurisdiction of incorporation</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={countryTitle === 'EE' ? 'Estonia' : countryTitle}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'row margin-top-25'}>
                        <div className={'col-lg-5'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Personal code</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={taxNumber}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col-lg-5 offset-lg-1'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Expiration date</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={expDate.toLocaleDateString()}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'row margin-top-50'} id="search-block">
                        <div className="col-lg-8 offset-lg-2">
                            {!companyHasSelected ?
                                <input type="text" className="form-control" placeholder="Search"
                                       onChange={this.onChangeSearchValue}/>
                                :
                                <div className="btn-group">
                                    <input type="text" className="form-control" value={selectedCompany.name}
                                           disabled={true}/>
                                    <span className="close-icon" onClick={this.cancelCompanies}></span>
                                </div>
                            }
                        </div>

                        {/*<div className={'col-lg-3 offset-lg-3 margin-top-10'}>*/}
                            {/*<div className={'fields-row padding-left-35'}>*/}
                                {/*<ButtonInput*/}
                                    {/*id="new-search-button"*/}
                                    {/*className={'dark-button black-btn search-bth'}*/}
                                    {/*title='New search'*/}
                                    {/*handleClick={(e) => this.cancelCompanies()}/>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        <div className={'col-lg-2 offset-lg-5 margin-top-10'}>
                            <div className={'fields-row'}>
                                <ButtonInput
                                    id="search-button"
                                    className={'dark-button black-btn search-bth'}
                                    title='Search'
                                    handleClick={(e) => this.search()}/>
                            </div>
                        </div>

                        {hasSearched &&
                        <div className="col-lg-8 offset-lg-2" id="search-result-block">
                            <table className={'table'}>
                                <thead>
                                <tr>
                                    <th scope="col" className={'wallet-selected'}>{companiesSelectedNumber}</th>
                                    <th scope="col">ID</th>
                                    <th scope="col">Company name</th>
                                </tr>
                                </thead>
                                <tbody>
                                {companiesList.map((company, index) => {
                                    return (
                                        <tr id={'inData-' + index} key={index}>
                                            <td>
                                                <input className={'big-checkbox inputAddress'} type="checkbox"
                                                       id={'company-' + index}
                                                       checked={!!company.selected}
                                                       onChange={(e) => {
                                                           this.changeSelectedCompany(index)
                                                       }}/>
                                            </td>
                                            <td id={'companyId-' + index}>
                                                {company.code}
                                            </td>
                                            <td id={'companyName-' + index}>
                                                {company.name}
                                            </td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        }
                    </div>
                    {companyHasSelected &&
                    <div className={'row margin-top-25'}>
                        <div className={'offset-lg-9 col-lg-3'}>
                            <div className={'fields-row'}>
                                <ButtonInput
                                    id="next-button"
                                    className={'dark-button black-btn'}
                                    title='Next'
                                    handleClick={this.next}/>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(SearchCompany);


// WEBPACK FOOTER //
// ./src/views/SearchCompany/SearchCompany.js